import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { Flex, ProgressCircle } from '@spotify-internal/encore-web';
import { getTypeOrNull, useReviewQuery } from '@spotify/confidence-graphql';

import { useCommentState } from '../../hooks/useCommentState';

const urlFromResource = (resource: string) =>
  `/${resource.replace('/instances', '')}`;

const ReviewsHandler = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const resourcePath = decodeURIComponent(location.pathname);
  const resourcePathReview = resourcePath.split('/')[2];

  const reviewId = `reviews/${resourcePathReview}`;

  const { data, error } = useReviewQuery({
    variables: {
      name: reviewId,
    },
  });

  const showMenu = useCommentState(state => state.enterCommentMode);
  const selectComment = useCommentState(state => state.selectComment);

  useEffect(() => {
    if (error) {
      navigate('/', { replace: true });
      return;
    }

    const handleAccount = async () => {
      const review = getTypeOrNull(data?.review);
      const responses = getTypeOrNull(review?.reviewResponses)?.reviewResponses;

      const response = responses?.find(r => resourcePath.includes(r.name));

      const commentId = getTypeOrNull(response?.comment)?.name;

      if (review?.resource) {
        const newUrl = urlFromResource(review.resource);

        navigate(newUrl, { replace: true });

        if (commentId) {
          showMenu();
          selectComment(commentId);
        }
      }
    };

    handleAccount();
  }, [data, error, navigate, showMenu, selectComment, resourcePath]);

  return (
    <Flex justifyContent="center" padding="base">
      <ProgressCircle aria-label="Loading review" />
    </Flex>
  );
};

export default ReviewsHandler;
